import {
    UPDATE_DOMAINS_REQUEST,
    UPDATE_DOMAINS_SUCCESS,
    UPDATE_DOMAINS_FAILURE,
    UPDATE_DOMAINS_PARTIAL_SUCCESS,
} from '../actions/types/domain-management-action-types';

import { combineReducers } from 'redux';
import { CLOSE_RIGHT_PANE } from '../actions/types/ui-state-action-types';

function manageBulkData( state = {}, action ){
    let newState;
    switch( action.type ){
        case UPDATE_DOMAINS_REQUEST:
        case UPDATE_DOMAINS_FAILURE:
        case CLOSE_RIGHT_PANE:
            newState = {};
            break;
        case UPDATE_DOMAINS_SUCCESS:
            newState = {
                successfulDomains: action.successfulDomains,
            };
            break;
        default:
            return state;
    }

    return newState;
}

function domainErrors( state = null, action ){
    let newState;
    switch( action.type ){
        case UPDATE_DOMAINS_REQUEST:
        case UPDATE_DOMAINS_FAILURE:
        case CLOSE_RIGHT_PANE:
            newState = null;
            break;
        case UPDATE_DOMAINS_PARTIAL_SUCCESS:
            newState = action.domainErrors;
            break;
        default:
            newState = state;
    }

    return newState;
}

function manageBulkIsLoading( state = false, action ){
    let newState;
    switch( action.type ){
        case UPDATE_DOMAINS_REQUEST:
            newState = true;
            break;
        case UPDATE_DOMAINS_SUCCESS:
        case UPDATE_DOMAINS_FAILURE:
        case UPDATE_DOMAINS_PARTIAL_SUCCESS:
            newState = false;
            break;
        default:
            return state;
    }

    return newState;
}
export default combineReducers( {
    domainErrors,
    manageBulkData,
    manageBulkIsLoading,
} );
